import axios from 'axios'

const ENDPOINT = 'menuitem'

export default {
  delete: async (sitePath, id) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    return await axios.get(url)
  },

  getAll: async sitePath => {
    const url = `${sitePath}/${ENDPOINT}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/${ENDPOINT}/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    return await axios.put(url, data)
  },

  getQMenuItems: async (sitePath, parent) => {
    let url = `${sitePath}/${ENDPOINT}/`
    if (parent) {
      const eparent = encodeURIComponent(parent)
      url += `?parent=${eparent}`
    }
    const response = await axios.get(url)

    return response.data
  },

  getQMenuItemsFull: async sitePath => {
    const response = await axios.get(`${sitePath}/${ENDPOINT}/?full=1`)

    return response.data
  },

  copyFromParent: async sitePath => {
    const url = `${sitePath}/${ENDPOINT}/copy_from_parent/`
    const response = await axios.get(url)

    return response.data
  },
}
